// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '15px 0',
  },
  text: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_YELLOW_SELECT,
    borderBottomColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
});

export default styles;
